import styled from 'styled-components'

export const Hr = styled.hr`
  width: 100%;
  border-color: ${({ theme }) => theme.primary.fgDim};
`
